import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';
import type { Role } from '@src/domain/rbac/entities/role.entity';
import type { UpdateRoleData } from '@src/domain/rbac/value_objects/update_role_data';

/**
 * Update Role Use Case
 * Updates an existing role
 */
export class UpdateRoleUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(roleId: string, data: UpdateRoleData): Promise<Role> {
        return await this.roleRepository.update(roleId, data);
    }
}
